import React from 'react';
import { useOutletContext, useParams } from 'react-router-dom';

import PermissionRolesShow from './PermissionRolesShow';
import PermissionRolesEdit from './PermissionRolesEdit';
import PermissionRolesCreate from './PermissionRolesCreate';

export const CREATE_ROLE = 'create';

export type OutletContext = {
  isEdit: boolean;
  setEdit: React.Dispatch<React.SetStateAction<boolean>>;
  setSelectedRole: (newRole: string | undefined) => void;
};

const PermissionRolesView = () => {
  const { permissionRoleId } = useParams();
  const {
    isEdit,
    setEdit,
    setSelectedRole,
  } = useOutletContext<OutletContext>();

  if (!permissionRoleId) return null;
  if (permissionRoleId === CREATE_ROLE) {
    return (
      <PermissionRolesCreate setSelectedRole={setSelectedRole} />
    );
  }
  if (isEdit) {
    return (
      <PermissionRolesEdit id={permissionRoleId} setEdit={setEdit} />
    );
  }
  return (
    <PermissionRolesShow
      id={permissionRoleId}
      setEdit={setEdit}
      setSelectedRole={setSelectedRole}
    />
  );
};

export default PermissionRolesView;
